import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

interface Account {
  id: number;
  wx_account_id: number;
  appid: string | null;
  display_name: string | null;
}

export default function AccountsPage() {
  const { user } = useAuth();
  const { data, isLoading, error } = useQuery<{ items: Account[] }>({
    queryKey: ['accounts'],
    queryFn: () => api.get('/api/accounts'),
  });

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-800">公众号</h2>
      {user?.role !== 'super' && (
        <p className="text-sm text-slate-500">公众号绑定与解绑由超管在超管视图操作；如需变更请联系平台。</p>
      )}
      {error && <div className="rounded bg-red-50 px-3 py-2 text-sm text-red-700">{(error as Error).message}</div>}
      <div className="card overflow-hidden p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2">名称</th>
              <th className="px-4 py-2">AppID</th>
              <th className="px-4 py-2">主系统 ID</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {isLoading && (
              <tr><td className="px-4 py-6 text-center text-slate-400" colSpan={3}>加载中...</td></tr>
            )}
            {!isLoading && (data?.items ?? []).length === 0 && (
              <tr><td className="px-4 py-6 text-center text-slate-400" colSpan={3}>尚未绑定公众号</td></tr>
            )}
            {(data?.items ?? []).map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-2 text-slate-800">{a.display_name || '-'}</td>
                <td className="px-4 py-2 font-mono text-xs text-slate-500">{a.appid || '-'}</td>
                <td className="px-4 py-2 text-slate-500">#{a.wx_account_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
